/* Attribution only. The private session stays in an HttpOnly cookie; no checkout is created here. */
(function () {
  'use strict';
  if (window.ffCommissionUpgradeBridge) { window.ffCommissionUpgradeBridge.scan(); return; }
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const commission = new URLSearchParams(location.hash.slice(1)).get('ff_commission');
  if (!uuid.test(commission || '')) return;
  const catalog = {
    '9960889909565': ['50407847166269'],
    '9980775104829': ['50474399596861'],
    '9821024354621': ['49911926948157', '49911926980925', '50365905469757', '51083775738173']
  };
  const controllers = new Map();
  const localeRoot = () => window.Shopify?.routes?.root || '/';
  async function json(url, options = {}) {
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, { credentials: 'include', cache: 'no-store', redirect: 'error', ...options, signal: controller.signal });
      const data = await response.json();
      if (!response.ok) throw new Error(data?.error?.message || data.message || 'Please return to your commission and try again.');
      return data;
    } catch (error) {
      if (error.name === 'AbortError') throw new Error('The connection took too long. Try again, or return to your commission.');
      throw error;
    } finally { clearTimeout(timer); }
  }
  function mount(marker) {
    const form = marker.closest('form'), variants = catalog[marker.dataset.ffUpgradeProduct];
    if (!form || !variants || controllers.has(form)) return;
    let sequence = 0, ready = null, pending = false, submitted = false, walletActive = false, changeTimer = null, cartTimer = null;
    const frozen = new Map();
    const product = form.closest('product-info') || form.closest('.shopify-section') || form;
    const api = new URL(marker.dataset.apiOrigin);
    if (api.protocol !== 'https:' || api.pathname !== '/' || api.search || api.hash) return;
    const status = document.createElement('div');
    status.className = 'ff-commission-upgrade-status';
    status.style.cssText = 'font-size:14px;line-height:1.5;margin:12px 0;';
    status.setAttribute('role', 'status');status.setAttribute('aria-live', 'polite');
    const note = document.createElement('p'), retry = document.createElement('button'), back = document.createElement('a');
    note.style.margin = '0 0 8px';retry.type = 'button';retry.textContent = 'Try again';retry.className = 'button button--secondary';
    retry.style.cssText = 'min-height:44px;margin-right:12px;display:none;';
    const portalPage = /^\/pages\/[a-z0-9-]+$/.test(marker.dataset.portalPage || '') ? marker.dataset.portalPage : '/pages/your-commission';
    back.href = portalPage + '?commission=' + encodeURIComponent(commission);back.textContent = 'Return to your commission';
    status.append(note, retry, back);marker.after(status);
    function field(name) {
      let input = form.querySelector('input[name="' + name + '"]');
      if (!input) { input = document.createElement('input');input.type = 'hidden';input.name = name;form.appendChild(input); }
      return input;
    }
    const intentField = field('properties[_ff_portal_intent]');
    // This non-secret marker only detects a repeated cart addition. The importer NEVER trusts it.
    const contextField = field('properties[_ff_portal_commission]');
    function selection() {
      const data = new FormData(form), variant = String(data.get('id') || ''), quantity = Number(data.get('quantity') || 1);
      return { variant, quantity, key: variant + ':' + quantity, valid: variants.includes(variant) && Number.isSafeInteger(quantity) && quantity >= 1 && quantity <= 10 };
    }
    function gate(blocked) {
      const buttons = form.querySelector('.product-form__buttons');
      if (buttons) buttons.inert = blocked;
      form.inert = false;
      form.dataset.ffUpgradeReady = blocked ? 'false' : 'true';
    }
    function message(text, allowRetry = false, cart = false) {
      // Dawn's .button sets display:inline-flex, which beats the hidden attribute, so the inline
      // display decides: "Try again" shows only when something actually needs retrying.
      note.textContent = text;retry.hidden = !allowRetry;retry.style.display = allowRetry ? '' : 'none';
      back.href = cart ? localeRoot() + 'cart' : portalPage + '?commission=' + encodeURIComponent(commission);
      back.textContent = cart ? 'Review your cart' : 'Return to your commission';
    }
    function invalidate(text = 'Connecting this upgrade to your commission…') {
      sequence++;ready = null;pending = false;submitted = false;intentField.value = '';contextField.value = '';gate(true);message(text);
    }
    function current() { const chosen = selection();return !!ready && chosen.valid && ready.key === chosen.key && ready.expires > Date.now() + 30000 && intentField.value === ready.reference; }
    async function prepare() {
      if (walletActive) return;
      clearTimeout(changeTimer);clearTimeout(cartTimer);invalidate();const turn = sequence, chosen = selection();pending = true;
      if (!chosen.valid) { pending = false;message('Choose an available upgrade and a quantity from 1 to 10.', true);return; }
      // Dawn removes the fragment when it updates ?variant=. Preserve this non-secret context on reload/back.
      const url = new URL(location.href);url.hash = new URLSearchParams({ ff_commission: commission }).toString();history.replaceState(history.state, '', url);
      try {
        const [session, cart] = await Promise.all([json(api.origin + '/api/session'), json(localeRoot() + 'cart.js')]);
        if (turn !== sequence || chosen.key !== selection().key) return;
        if (!session?.actor?.id || !session.csrf) throw new Error('Open your private commission link again before buying an upgrade.');
        if (!Array.isArray(cart.items)) throw new Error('Your cart could not be checked. Please try again.');
        if (cart.items.some(item => String(item.variant_id || item.id) === chosen.variant && item.properties?._ff_portal_commission === commission)) {
          pending = false;message('This upgrade for your portrait is already in your cart. Review it there to avoid buying it twice.', false, true);return;
        }
        const requestId = crypto.randomUUID();
        const result = await json(api.origin + '/api/command', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': session.csrf }, body: JSON.stringify({ action: 'intents.create', payload: { request_id: requestId, commission_id: commission, variant_id: chosen.variant, quantity: chosen.quantity } }) });
        if (turn !== sequence || chosen.key !== selection().key) return;
        if (!/^[0-9a-f]{64}$/i.test(result.reference || '') || !Number.isFinite(Date.parse(result.expires_at)) || Date.parse(result.expires_at) <= Date.now() + 30000) throw new Error('This upgrade link could not be prepared. Please try again.');
        intentField.value = result.reference;contextField.value = commission;
        ready = { key: chosen.key, reference: result.reference, expires: Date.parse(result.expires_at) };pending = false;
        gate(false);message('This purchase will be connected to your commission.');
      } catch (error) { if (turn === sequence) { pending = false;message(error.message || 'Please try again.', true); } }
    }
    function blockUnlessReady(event) {
      if (walletActive) {
        if (event.target.closest('.shopify-payment-button')) return true;
        event.preventDefault();event.stopImmediatePropagation();return false;
      }
      if (current() && !submitted) return true;
      event.preventDefault();event.stopImmediatePropagation();gate(true);
      if (!pending && !submitted) prepare();return false;
    }
    function nativeAttempt(wallet) {
      if (wallet) {
        if (walletActive) return;
        walletActive = true;
        // Preserve the ready reference and the wallet's own DOM through its multi-click flow.
        // Freeze only external selection controls; never disable wallet descendants or the hidden variant.
        product.querySelectorAll('variant-selects input,variant-selects select,variant-selects button,input[name="quantity"],.quantity__button').forEach(input => {
          if (!input.closest('.shopify-payment-button')) {
            const property = input.name === 'quantity' ? 'readOnly' : 'disabled';
            frozen.set(input, { property, value: input[property] });input[property] = true;
          }
        });
        message('Finish checkout. If you close it, choose Try again to change your selection.', true);return;
      }
      submitted = true;
      setTimeout(() => { if (submitted) { gate(true);message('Checking your cart…'); } }, 0);
      cartTimer = setTimeout(prepare, 12000);
    }
    form.addEventListener('submit', event => { if (blockUnlessReady(event)) nativeAttempt(false); }, true);
    form.addEventListener('click', event => {
      if (event.target.closest('.product-form__buttons') && blockUnlessReady(event) && event.target.closest('.shopify-payment-button')) nativeAttempt(true);
    }, true);
    product.addEventListener('change', event => {
      if (walletActive) return;
      const target = event.target;
      if (target.name === 'id' && target.form === form || target.name === 'quantity' && target.form === form) {
        // Browsers emit quantity change again on blur. A ready, identical selection must
        // survive that event so the first checkout click can reach the wallet.
        if (!current()) prepare();
      }
      else if (target.closest('variant-selects')) {
        invalidate('Updating your selected upgrade…');
        clearTimeout(changeTimer);changeTimer = setTimeout(() => message('Your selection could not be checked. Try again.', true), 12000);
      }
    }, true);
    product.addEventListener('input', event => {
      if (walletActive) return;
      if (event.target.name !== 'quantity' || event.target.form !== form) return;
      if (current()) return;
      invalidate('Updating the upgrade quantity…');clearTimeout(changeTimer);changeTimer = setTimeout(prepare, 250);
    }, true);
    function resume() { walletActive = false;for (const [input, old] of frozen) if (input.isConnected) input[old.property] = old.value;frozen.clear();prepare(); }
    retry.addEventListener('click', resume);
    async function focus() {
      if (walletActive || pending) return;
      if (!current()) { prepare();return; }
      // Focusing a tab must not swallow the user's first Buy/Wallet click by clearing a ready intent.
      const turn = sequence, chosen = selection();
      try {
        const cart = await json(localeRoot() + 'cart.js');
        if (!walletActive && turn === sequence && cart.items?.some(item => String(item.variant_id || item.id) === chosen.variant && item.properties?._ff_portal_commission === commission)) {
          invalidate();message('This upgrade for your portrait is already in your cart. Review it there to avoid buying it twice.', false, true);
        }
      } catch (_) { /* Keep the still-valid intent; no cart or ownership mutation occurred. */ }
    }
    controllers.set(form, { prepare, resume, invalidate, focus });prepare();
  }
  function scan() {
    document.querySelectorAll('[data-ff-upgrade-product]').forEach(mount);
    for (const form of controllers.keys()) if (!form.isConnected) controllers.delete(form);
  }
  window.ffCommissionUpgradeBridge = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });else scan();
  const observer = new MutationObserver(() => scan());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', event => { if (event.persisted) for (const value of controllers.values()) value.resume(); });
  window.addEventListener('focus', () => { for (const value of controllers.values()) value.focus(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    for (const event of [PUB_SUB_EVENTS.cartUpdate, PUB_SUB_EVENTS.cartError]) {
      if (event) subscribe(event, () => { for (const value of controllers.values()) value.prepare(); });
    }
  }
})();
